<template functional>
  <div class="footer">
    <div class="footer-content-column" style="text-align:center;">
      <!-- <logo :is-transparent="true"></logo> -->
      <!-- <p class="title">© 2012-2020 北京字节跳动科技有限公司</p> -->
      <img
        style="width: 260px;"
        src="http://boss.hangyunzx.com/static/pcimg/logo.jpg"
      />
      <p class="title">© 2021 江苏中宏航运科技有限公司</p>
      <a target="_blank" href="http://beian.miit.gov.cn" class="title"
        ><p>苏ICP备2021028791号-3</p></a
      >
    </div>
    <div class="footer-content-column">
      <div class="title">联系我们</div>
      <p>联系地址：连云港市连云区嘉福大厦402室</p>
      <p>电话：+(86)18961318999</p>
      <p>Email：178923246@qq.com</p>
    </div>
    <div class="footer-content-column">
      <div class="title">企业官网</div>
      <p></p>
      <a target="_blank" href="http://hangyunzx.com"
        >江苏中宏航运科技有限公司</a
      >
      <!-- <p>字节跳动</p> -->
    </div>
    <div class="footer-content-column" style="text-align:center;">
      <div class="title">实时动态与信息，请关注我们</div>
      <ul  style="margin-top:20px;">
        <img style="width:70px" src="http://oss.hangyunzx.com/1650336136109.jpg">
        <img style="width:70px;margin-left:27px;" src="http://oss.hangyunzx.com/app.png">
      </ul>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style lang="less" scoped>
.footer {
  height: 220px;
  min-width: @main-width;
  background: #1f2329;
  color: #fff;
  display: flex;
  font-size: @font-size-small;
  padding: 0 150px;
  justify-content: space-between;
  align-items: center;
  white-space: nowrap;
  &-content-column {
    padding: 0 40px;
    height: 100px;
    .title {
      color: @secondary-text-color;
    }
    &:last-child {
      width: 340px;
      padding: 0 80px;
    }
    & + & {
      text-align: center;
      flex: 1;
      border-left: 1px solid @border-dark-color;
    }

    &__contact {
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      .contact-item {
        border-radius: 50%;
        width: 33px;
        height: 33px;
        overflow: hidden;
      }
    }
  }
}
</style>
